import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "button"]

  connect() {
    // Default hidden
    if (!this.panelTarget.style.display) {
      this.panelTarget.style.display = "none"
    }
  }

  toggle() {
    const isHidden = this.panelTarget.style.display === "none"
    this.panelTarget.style.display = isHidden ? "block" : "none"
    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = isHidden ? "Hide Preview" : "Show Preview"
    }
  }
}


